import {ProductType} from '@wix/wixstores-client-core/dist/es/src/types/product';
import {RootStoreState} from '../../stores/RootStoreState';

export const isDigitalProduct = (rootState: RootStoreState): boolean => {
  return rootState.product.productType === ProductType.DIGITAL;
};
